<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="44"
    viewBox="0 0 45 44"
    fill="none"
  >
    <mask
      id="mask0_3427_32260"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="45"
      height="44"
    >
      <rect
        x="0.85022"
        y="0.400024"
        width="43.2"
        height="43.2"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_3427_32260)">
      <path
        d="M9.85024 38.2C8.86024 38.2 8.01274 37.8475 7.30774 37.1425C6.60274 36.4375 6.25024 35.59 6.25024 34.6V9.40002C6.25024 8.41002 6.60274 7.56252 7.30774 6.85752C8.01274 6.15252 8.86024 5.80002 9.85024 5.80002H35.0502C36.0402 5.80002 36.8877 6.15252 37.5927 6.85752C38.2977 7.56252 38.6502 8.41002 38.6502 9.40002V34.6C38.6502 35.59 38.2977 36.4375 37.5927 37.1425C36.8877 37.8475 36.0402 38.2 35.0502 38.2H9.85024ZM9.85024 34.6H35.0502V29.2H29.6502C28.7502 30.34 27.6777 31.225 26.4327 31.855C25.1877 32.485 23.8602 32.8 22.4502 32.8C21.0402 32.8 19.7127 32.485 18.4677 31.855C17.2227 31.225 16.1502 30.34 15.2502 29.2H9.85024V34.6ZM22.4502 29.2C23.4102 29.2 24.2952 28.9525 25.1052 28.4575C25.9152 27.9625 26.5752 27.31 27.0852 26.5C27.2652 26.23 27.4902 26.0125 27.7602 25.8475C28.0302 25.6825 28.3302 25.6 28.6602 25.6H35.0502V9.40002H9.85024V25.6H16.2402C16.5702 25.6 16.8702 25.6825 17.1402 25.8475C17.4102 26.0125 17.6352 26.23 17.8152 26.5C18.3252 27.31 18.9852 27.9625 19.7952 28.4575C20.6052 28.9525 21.4902 29.2 22.4502 29.2Z"
        fill="#3F3F3F"
      />
    </g>
  </svg>
</template>
